<template>
    <v-container fluid>
        <v-card class="card-format">
            <div class="card-section-header px-6 py-4">
                <div class="d-flex align-center flex-wrap" style="gap:10px;">
                    <v-text-field @input="debounceSearch()" placeholder="Search" v-model="search" dense outlined
                        hide-details prepend-inner-icon="mdi-magnify" clearable style="width:300px;"
                        class="header-filter-input">
                    </v-text-field>
                    <v-select v-if="view === 'closeoff'" @change="changeWeeks()" :items="weekOptions"
                        v-model="weeks" dense outlined hide-details style="width:160px;"
                        class="header-filter-input">
                        <template v-slot:selection="{ item }">Next {{ item }} week{{ item > 1 ? 's' : '' }}</template>
                        <template v-slot:item="{ item }">Next {{ item }} week{{ item > 1 ? 's' : '' }}</template>
                    </v-select>
                    <v-select v-if="view === 'past'" @change="fetchEvents(1)" :items="bookingStatusOptions"
                        item-text="label" item-value="value" placeholder="All Bookings"
                        v-model="filter_booking_status" dense outlined hide-details clearable
                        style="width:160px;" class="header-filter-input">
                    </v-select>
                    <div class="date-range-wrapper">
                        <v-icon size="16" color="#7C7C7C" class="mr-1">mdi-calendar</v-icon>
                        <v-dialog v-model="menu1" max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="filter_start_date" label="Start Date" readonly v-bind="attrs"
                                    v-on="on" dense hide-details style="max-width:105px;" class="date-range-input">
                                </v-text-field>
                            </template>
                            <v-date-picker v-if="menu1" v-model="filter_start_date" full-width
                                @change="changeStartDate()">
                            </v-date-picker>
                        </v-dialog>
                        <v-dialog v-model="menu2" max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="filter_end_date" label="End Date" readonly v-bind="attrs"
                                    v-on="on" dense hide-details style="max-width:105px;" class="date-range-input">
                                </v-text-field>
                            </template>
                            <v-date-picker v-if="menu2" v-model="filter_end_date" full-width
                                @change="changeEndDate()">
                            </v-date-picker>
                        </v-dialog>
                    </div>
                    <v-select @change="fetchEvents(1)" :items="getEventTypes" item-text="name" item-value="name"
                        placeholder="All Types" v-model="filter_type" dense outlined hide-details clearable
                        style="width:140px;" class="header-filter-input">
                    </v-select>
                    <v-select @change="fetchEvents(1)" :items="getLocation" placeholder="All Locations"
                        v-model="filter_location" item-text="name" item-value="id" dense outlined hide-details
                        clearable style="width:170px;" class="header-filter-input">
                    </v-select>
                    <v-autocomplete @change="fetchEvents(1)" :items="contributorFilterOptions"
                        :filter="filterContributorOptions" placeholder="All Contributors"
                        v-model="filter_contributor_id" item-text="name" item-value="id" dense outlined
                        hide-details clearable style="width:220px;" class="header-filter-input">
                        <template v-slot:selection="{ item }">
                            <span>{{ item.name }}</span>
                            <v-chip x-small class="ml-2" color="#3988AA" text-color="white"
                                v-if="item.role">{{ item.role.name }}</v-chip>
                        </template>
                        <template v-slot:item="{ item }">
                            <span>{{ item.name }}</span>
                            <v-chip x-small class="ml-2" color="#3988AA" text-color="white"
                                v-if="item.role">{{ item.role.name }}</v-chip>
                        </template>
                    </v-autocomplete>
                    <v-spacer></v-spacer>
                    <v-btn outlined depressed class="events-header-btn header-outline-btn" @click="fetchEvents()"
                        :loading="loading">
                        <v-icon left>mdi-refresh</v-icon>
                        Refresh
                    </v-btn>
                </div>
                <div v-if="hasActiveFilters" class="header-clear-row">
                    <v-btn x-small text class="header-clear-btn" @click="reset()">
                        <v-icon left x-small>mdi-close</v-icon>
                        Clear filters
                    </v-btn>
                </div>
            </div>
            <v-card-text class="pa-0 px-5">
                <v-data-table :headers="computedHeaders" :items="events" :single-expand="singleExpand"
                    :expanded.sync="expanded" item-key="id" :loading="loading" loading-text="Loading events..."
                    :server-items-length="events_total" hide-default-footer>
                    <template v-slot:item="{ item, expand, isExpanded }">
                        <tr style="cursor:initial;font-weight:600;">
                            <!-- <td>
                                    <v-avatar color="#4374F3" size="42">
                                        <label style="color:white;font-size:16px;">
                                            {{ item.lead.first_name[0] + item.lead.last_name[0] }}
                                        </label>
                                    </v-avatar>
                                </td> -->
                            <td>
                                <div style="display:flex;justify-content:space-between;align-items:center;">
                                    <div>
                                        <a :href="$router.resolve({ name: 'ManageEvent', params: { event_id: item.id } }).href"
                                            class="event-name-link" @click.prevent="manageEvent(item)">{{ item.name }}</a>
                                        <br>
                                        <small style="color:#4374F3">{{ item.reference_code }}</small>
                                        <br>
                                        <EventStatusSelect :value="item.event_status" small
                                            @change="updateEventStatus(item, $event)" class="mt-1 event-status-select"
                                            style="width:165px; min-width:165px;position:relative;left:-5px;margin-right:-20px;" />
                                    </div>
                                    <div style="width:20px;flex-direction: column;" class="d-flex align-center">
                                        <v-tooltip bottom :color="hasEventNotes(item) ? 'green' : 'grey'">
                                            <template v-slot:activator="{ on, attrs }">
                                                <button type="button" class="notes-square-btn"
                                                    :class="{ 'notes-square-btn--active': hasEventNotes(item) }"
                                                    v-bind="attrs" v-on="on" @click="openNotesDialog(item)">
                                                    N
                                                </button>
                                            </template>
                                            <span>{{ hasEventNotes(item) ? 'View / Add Notes' : 'Add Notes' }}</span>
                                        </v-tooltip>
                                        <v-tooltip bottom color="orange" v-if="item.free_stag_hen">
                                            <template v-slot:activator="{ attrs, on }">
                                                <v-btn small dense icon v-bind="attrs" v-on="on">
                                                    <v-icon color="orange">mdi-star</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Free Stag/Hen</span>
                                        </v-tooltip>
                                        <v-tooltip bottom color="primary" v-if="item.bar_crawl">
                                            <template v-slot:activator="{ attrs, on }">
                                                <v-btn small dense icon v-bind="attrs" v-on="on">
                                                    <v-icon color="blue">mdi-star</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Bar Crawl</span>
                                        </v-tooltip>
                                        <v-tooltip bottom color="green" v-if="item.itinerary_sent">
                                            <template v-slot:activator="{ attrs, on }">
                                                <v-btn small dense icon v-bind="attrs" v-on="on">
                                                    <v-icon color="green">mdi-email-check-outline</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Organiser Itinerary Email Sent</span>
                                        </v-tooltip>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <a :href="$router.resolve({ name: 'EditLeads', params: { id: item.lead.id } }).href"
                                        class="event-name-link" @click.prevent="openLead(item)">{{ item.lead.first_name + ' ' + (item.lead.last_name ?? '') }}</a>
                                    <br>
                                    <v-chip x-small label v-if="item.lead.event_type"
                                        :color="item.lead.event_type.name === 'Hen' ? 'pink lighten-4' : item.lead.event_type.name === 'Birthday' ? 'green lighten-4' : item.lead.event_type.name === 'Party' ? 'orange lighten-4' : 'blue lighten-4'"
                                        :text-color="item.lead.event_type.name === 'Hen' ? 'pink darken-3' : item.lead.event_type.name === 'Birthday' ? 'green darken-3' : item.lead.event_type.name === 'Party' ? 'orange darken-3' : 'blue darken-3'">{{
                                            item.lead.event_type.name
                                        }} <label v-if="item.lead.event_type.name !== 'Party'"
                                            style="white-space:preserve;">
                                            Party</label>
                                    </v-chip>
                                </div>
                            </td>
                            <td>
                                <div v-if="!item.contributors || item.contributors.length === 0">
                                    <small style="color:grey;">-</small>
                                </div>
                                <div v-for="contributor in sortedEventContributors(item)" :key="contributor.id"
                                    class="mb-1 contributor-row">
                                    <small>{{ contributor.user?.name }}</small>
                                    <v-chip x-small class="ml-1" color="#3988AA" text-color="white"
                                        v-if="contributor.user?.role">
                                        {{ contributor.user.role.name }}
                                    </v-chip>
                                </div>
                            </td>
                            <td>
                                <small>{{ item.lead.location?.name }}</small>
                            </td>
                            <td>
                                <small>{{ $date(item.lead.start_date).format('DD/MM/YYYY') }}</small>
                                <br>
                                <small style="color:#4374F3">{{ item.lead.duration }} night{{ item.lead.duration == 1 ? '' : 's' }}</small>
                            </td>
                            <td style="text-align:center;"
                                :title="`${paymentCounts[item.id].full} paid in full, ${paymentCounts[item.id].deposit} paid deposit only, ${paymentCounts[item.id].total - paymentCounts[item.id].full - paymentCounts[item.id].deposit} unpaid (organiser + ${paymentCounts[item.id].total - 1} invitees)`">
                                <div class="paid-bar">
                                    <div class="paid-bar-full" :style="{ width: (paymentCounts[item.id].full / paymentCounts[item.id].total * 100) + '%' }"></div>
                                    <div class="paid-bar-deposit" :style="{ width: (paymentCounts[item.id].deposit / paymentCounts[item.id].total * 100) + '%' }"></div>
                                </div>
                                <div class="paid-counts">
                                    <span class="paid-count-full">Full {{ paymentCounts[item.id].full }}/{{ paymentCounts[item.id].total }}</span>
                                    <span class="paid-count-deposit">Dep {{ paymentCounts[item.id].deposit }}/{{ paymentCounts[item.id].total }}</span>
                                </div>
                                <!-- Minimum group size per package (MINIMUM_GROUP_SIZE.md): red when fewer have paid -->
                                <div v-for="check in minimumChecks[item.id]" :key="check.quote_id"
                                    :class="['min-check', check.short > 0 ? 'min-check--short' : 'min-check--ok']"
                                    :title="minimumCheckTitle(item, check)">
                                    <v-icon x-small :color="check.short > 0 ? '#C62828' : '#2E7D32'">
                                        {{ check.short > 0 ? 'mdi-alert' : 'mdi-check-circle' }}
                                    </v-icon>
                                    Min {{ check.paid }}/{{ check.minimum }}
                                </div>
                                <!-- <td :set_org="org_paid = item.lead.payments.filter((item) => item.status == 'Organizer Payment')[0] ? 1 : 0"
                                    :set="percentage = (item.invitees.filter((val) => val.payments.filter((item) => item.status == 'Full Payment')[0]).length + org_paid) / (item.invitees.length + 1) * 100"> -->
                                <!-- <v-progress-linear v-if="item.invitees.length > 0" height="15" rounded
                                        :value="(percentage).toFixed(0)" color="green" background-color="#D7D7D7"
                                        style="border-radius:20px;">
                                        <strong style="color:white;font-size:10px;">
                                            {{ (percentage).toFixed(0) }}%</strong>
                                    </v-progress-linear>
                                    <small v-else>No invitees yet</small> -->
                            </td>
                            <td>
                                <div :set="accomBuilds = getBuildsOfType(item, 1)">
                                    <div v-if="accomBuilds.length > 0">
                                        <div v-for="build in accomBuilds" :key="build.id" class="build-row-item"
                                            style="display:flex;align-items:center;">
                                            <div v-if="showSupplierEmails" style="margin-right:4px;">
                                                <v-checkbox :input-value="isBuildTicked(item, build)"
                                                    @change="toggleBuild(item, build)" dense hide-details class="mt-0 pt-0" />
                                            </div>
                                            <div style="display:flex;align-items:center;flex:1;gap:4px;min-width:0;">
                                                <small
                                                    style="flex:1;min-width:0;white-space:normal;word-break:break-word;">
                                                    {{ build.supplier?.supplier_name }}
                                                </small>
                                                <div v-if="build.option" style="flex:1;min-width:0;">
                                                    <v-chip x-small :class="['label-' + build.booking_status_id]"
                                                        style="height:auto;white-space:normal;word-break:break-word;">
                                                        {{ stripParenthetical(build.option.name) }}
                                                    </v-chip>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div :set="activityGroups = getGroupedBuildsOfTypes(item, catchAllTypeIds)">
                                    <div v-for="group in activityGroups" :key="group.label" class="build-group">
                                        <div class="build-group-label">{{ group.label }}</div>
                                        <div v-for="build in group.builds" :key="build.id" class="build-row-item"
                                            style="display:flex;align-items:center;">
                                            <div v-if="showSupplierEmails" style="margin-right:4px;">
                                                <v-checkbox :input-value="isBuildTicked(item, build)"
                                                    @change="toggleBuild(item, build)" dense hide-details class="mt-0 pt-0" />
                                            </div>
                                            <div style="display:flex;align-items:center;flex:1;gap:4px;min-width:0;">
                                                <small
                                                    style="flex:1;min-width:0;white-space:normal;word-break:break-word;">
                                                    {{ build.supplier?.supplier_name }}
                                                </small>
                                                <div v-if="build.option" style="flex:1;min-width:0;">
                                                    <v-chip x-small :class="['label-' + build.booking_status_id]"
                                                        style="height:auto;white-space:normal;word-break:break-word;">
                                                        {{ stripParenthetical(build.option.name) }}
                                                    </v-chip>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <!-- <td>
                                    <div
                                        style="overflow-x:scroll;max-width:150px;display:flex;align-items:center;justify-items:center;">
                                        <label v-if="item.disable_payment" class="custom-label">Disabled</label>
                                        <label v-if="item.late_fee == 0" class="custom-label">Late Fee Disabled</label>
                                        <label v-if="item.is_fully_paid" class="custom-label">Fully Paid</label>
                                    </div>
                                </td> -->
                            <td>
                                <div class="event-actions">
                                    <div class="event-actions-buttons">
                                        <v-menu bottom offset-y>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-bind="attrs" v-on="on" class="custom-buttons events-action-btn"
                                                    color="#3988AA" dark depressed rounded small>
                                                    Email Organiser
                                                    <v-icon small right>mdi-chevron-down</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-list dense>
                                                <v-list-item @click="sendOrganiserEmail(item)">
                                                    <v-icon v-if="hasOrganiserEmailBeenSent(item, 'organiser_login_details')"
                                                        small color="green" class="mr-2">mdi-check-circle</v-icon>
                                                    <v-list-item-title>Login Details</v-list-item-title>
                                                </v-list-item>
                                                <v-list-item @click="openSendOrganiserItineraryDialog(item)">
                                                    <v-icon v-if="hasOrganiserEmailBeenSent(item, 'organiser_itinerary')"
                                                        small color="green" class="mr-2">mdi-check-circle</v-icon>
                                                    <v-list-item-title>Itinerary</v-list-item-title>
                                                </v-list-item>
                                                <v-list-item @click="openSendOrganiserBalanceDueDialog(item)">
                                                    <v-icon v-if="hasOrganiserEmailBeenSent(item, 'organiser_balance_due')"
                                                        small color="green" class="mr-2">mdi-check-circle</v-icon>
                                                    <v-list-item-title>Balance Due Reminder</v-list-item-title>
                                                </v-list-item>
                                                <v-list-item @click="openSendOrganiserDepositsReminderDialog(item)">
                                                    <v-icon v-if="hasOrganiserEmailBeenSent(item, 'organiser_deposits_reminder')"
                                                        small color="green" class="mr-2">mdi-check-circle</v-icon>
                                                    <v-list-item-title>Per Person Deposits Reminder</v-list-item-title>
                                                </v-list-item>
                                                <v-list-item @click="openSendFinalGuestListDialog(item)">
                                                    <v-icon v-if="hasOrganiserEmailBeenSent(item, 'organiser_final_guest_list')"
                                                        small color="green" class="mr-2">mdi-check-circle</v-icon>
                                                    <v-list-item-title>Final Guest List</v-list-item-title>
                                                </v-list-item>
                                                <v-list-item @click="openSendPaymentSummaryDialog(item)">
                                                    <v-icon v-if="hasOrganiserEmailBeenSent(item, 'organiser_payment_summary')"
                                                        small color="green" class="mr-2">mdi-check-circle</v-icon>
                                                    <v-list-item-title>Payment Summary</v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                        <!-- The event's suppliers: a template, or a booking change email. Every
                                             supplier starts ticked, or only the services ticked on this row -->
                                        <SupplierTemplateMenu v-if="showSupplierEmails" :templates="email_templates" :loading="loading_templates"
                                            availability @availability="openAvailability(item)"
                                            @select="openSupplierEmails(item, $event)" @change="openChangeEmails(item, $event)">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-bind="attrs" v-on="on" class="custom-buttons events-action-btn"
                                                    color="#3988AA" outlined depressed rounded small>
                                                    Email Suppliers{{ tickedFor(item) ? ` (${tickedFor(item).length})` : '' }}
                                                    <v-icon small right>mdi-chevron-down</v-icon>
                                                </v-btn>
                                            </template>
                                        </SupplierTemplateMenu>
                                    </div>
                                    <v-tooltip bottom color="primary">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn small dense icon v-bind="attrs" v-on="on" @click="expand(!isExpanded)">
                                                <v-icon>{{ isExpanded ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Expand</span>
                                    </v-tooltip>
                                </div>
                            </td>
                        </tr>
                    </template>

                    <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length">
                            <v-card class="card-format" style="background-color:#FAFAFA;margin-bottom:20px;">
                                <v-card-text>
                                    <v-row style="color:#101010;font-size:12px;">
                                        <v-col>
                                            <v-icon small color="#3988AA">mdi-phone-outline</v-icon>
                                            {{ item.lead.phone }}
                                            <br>
                                            <v-icon small color="#3988AA">mdi-email-outline</v-icon>
                                            {{ item.lead.email }}
                                            <br>
                                            <v-icon small color="#3988AA">mdi-map-marker-outline</v-icon>
                                            {{ item.lead.location?.name }}
                                        </v-col>
                                        <!-- <v-col>
                                                <b style="color:#3988AA!important;">NOTES:</b>
                                                <div>{{ item.notes ?? 'None' }}</div>
                                            </v-col> -->
                                        <v-col>
                                            <b style="color:#3988AA!important;">GROUP SIZE:</b>
                                            {{ item.lead.people }}
                                            <br>
                                            <b style="color:#3988AA!important;">EVENT CREATED AT:</b>
                                            {{ $date(item.created_at).format('DD/MM/YYYY') }}
                                            <br>
                                            <b style="color:#3988AA!important;">EVENT CODE:</b>
                                            {{ item.reference_code }}
                                            <br>
                                            <!-- <b style="color:#3988AA!important;">CONFIRMATION EMAIL:</b> -->
                                            <!-- {{ $date().format('DD/MM/YYYY') }} -->
                                        </v-col>
                                        <v-col>
                                            <b style="color:#3988AA!important;">PASSWORD:</b>
                                            {{ item.password }}
                                            <br>
                                            <label v-if="item.free_stag_hen" class="label-2 mr-2">
                                                FREE STAG/HEN</label>
                                            <label v-if="item.bar_crawl" class="label-2">BAR CRAWL</label>
                                            <!-- <br>
                                                <b style="color:#3988AA!important;">PENDING:</b>
                                                {{ get_selected_company.currency }}{{ item.deposit_amount }} -->
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </td>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>

        <div class="sticky-pagination" v-if="page_count > 1">
            <v-pagination v-model="page" :length="page_count" :total-visible="7" @input="fetchEvents"></v-pagination>
        </div>

        <v-dialog v-model="notes_dialog" max-width="800px" persistent>
            <v-card class="booking-dialog-card">
                <div class="booking-dialog-header pa-5">
                    <div class="d-flex align-center justify-space-between">
                        <div class="booking-dialog-title">
                            <v-icon class="mr-2" color="white" size="20">mdi-note-text-outline</v-icon>
                            Event Notes
                        </div>
                        <v-btn icon dark @click="closeNotesDialog()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </div>
                <v-card-text class="pa-5">
                    <div class="notes-container mb-4">
                        <div v-if="!selected_event || !selected_event.event_notes || selected_event.event_notes.length === 0"
                            class="no-notes">
                            No notes yet
                        </div>
                        <div v-for="note in selected_event ? selected_event.event_notes : []" :key="note.id"
                            class="note-item">
                            <div class="note-header">
                                <div class="note-meta">
                                    <label class="note-date">
                                        {{ $date(note.created_at).format('DD/MM/YYYY HH:mm') }}
                                    </label>
                                    <label v-if="note.creator" class="note-author"> •
                                        {{ note.creator.name }}
                                    </label>
                                        <label class="note-author" style="color:#7F8C8D;font-weight:400;"> • {{ noteOrigin(note) }}</label>
                                </div>
                                <v-btn icon x-small @click="deleteEventNote(note)">
                                    <v-icon x-small color="error">mdi-delete-outline</v-icon>
                                </v-btn>
                            </div>
                            <div class="note-content">{{ note.note_content }}</div>
                        </div>
                    </div>
                    <v-textarea v-model="new_note_content" outlined dense hide-details auto-grow
                        placeholder="Add a note..." rows="3"></v-textarea>
                </v-card-text>
                <v-divider />
                <v-card-actions class="pa-4 custom-buttons">
                    <v-spacer></v-spacer>
                    <v-btn text @click="closeNotesDialog()">Cancel</v-btn>
                    <v-btn dark color="#3988AA" @click="createEventNote()" :disabled="!new_note_content">Add
                        Note</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <PreviewOrganiserEmail v-if="organiser_email_event" :show="organiser_email_dialog"
            :lead="organiser_email_event.lead" :event="organiser_email_event" :company_id="get_selected_company.id"
            @close="closeOrganiserEmailDialog()">
        </PreviewOrganiserEmail>
        <PreviewOrganiserItineraryEmail v-if="organiser_itinerary_event" :show="organiser_itinerary_dialog"
            :lead="organiser_itinerary_event.lead" :event="organiser_itinerary_event"
            :company_id="get_selected_company.id" @close="closeSendOrganiserItineraryDialog()">
        </PreviewOrganiserItineraryEmail>
        <PreviewOrganiserBalanceDueEmail v-if="organiser_balance_due_event" :show="organiser_balance_due_dialog"
            :lead="organiser_balance_due_event.lead" :event="organiser_balance_due_event"
            :company_id="get_selected_company.id" @close="closeSendOrganiserBalanceDueDialog()">
        </PreviewOrganiserBalanceDueEmail>
        <PreviewOrganiserDepositsReminderEmail v-if="organiser_deposits_reminder_event"
            :show="organiser_deposits_reminder_dialog" :lead="organiser_deposits_reminder_event.lead"
            :event="organiser_deposits_reminder_event" :company_id="get_selected_company.id"
            @close="closeSendOrganiserDepositsReminderDialog()">
        </PreviewOrganiserDepositsReminderEmail>
        <PreviewFinalGuestListEmail v-if="final_guestlist_event" :show="final_guestlist_dialog"
            :lead="final_guestlist_event.lead" :event="final_guestlist_event" @close="closeSendFinalGuestListDialog()">
        </PreviewFinalGuestListEmail>
        <!-- Same rows as Event → Invitees' Payment Summary (utils/eventPayments.js) -->
        <PreviewOrganiserPaymentSummaryEmail v-if="payment_summary_event" :show="payment_summary_dialog"
            :lead="payment_summary_event.lead" :event="payment_summary_event" :company_id="get_selected_company.id"
            :currency="get_selected_company.currency" :rows="paymentSummaryRowsFor(payment_summary_event)"
            @close="closeSendPaymentSummaryDialog()">
        </PreviewOrganiserPaymentSummaryEmail>
        <!-- Email Suppliers: a template or booking change email to the event's suppliers, previewed per supplier -->
        <SupplierEmailsDialog :show="supplier_email.show" :title="supplier_email.title" :subtitle="supplier_email.subtitle"
            :email_type="supplier_email.email_type" :items="supplier_email.items" :event="supplier_email.event || {}"
            :note="supplier_email.note" :sent_services="dialogSentServices"
            @close="supplier_email.show = false" @sent="onSupplierEmailsSent()" />
        <!-- Request Availability: the event's suppliers (or the ticked services') with their products picked -->
        <RequestAvailabilityDialog v-if="availability.event" v-model="availability.show" :lead="availability.event.lead"
            :location-name="availability.event.lead.location ? availability.event.lead.location.name : 'this location'"
            :preset-supplier-ids="availability.supplier_ids" :preset-product-ids="availability.product_ids"
            :builds="availability.builds" only-preset />
    </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import { dedupeLinkedBuilds } from "@/utils/linkedBuilds"
import { eventPaymentCounts, eventMinimumChecks, paymentSummaryRows } from "@/utils/eventPayments"
import { loadEmailTemplates, loadSentServicesForEvents, templateEmailItems, templateEmailNote } from "@/utils/supplierTemplateEmails"
import { changeEmailDialog, deletedBuildGroups } from "@/utils/supplierChangeEmails"
import SupplierEmailsDialog from "./components/SupplierEmailsDialog.vue"
import SupplierTemplateMenu from "./components/SupplierTemplateMenu.vue"
import RequestAvailabilityDialog from "../suppliers/availability/RequestAvailabilityDialog.vue"
import { availabilityPreset } from "@/utils/supplierAvailability"
import PreviewFinalGuestListEmail from "./components/PreviewFinalGuestListEmail.vue"
import PreviewOrganiserEmail from "./components/PreviewOrganiserEmail.vue"
import PreviewOrganiserItineraryEmail from "./components/PreviewOrganiserItineraryEmail.vue"
import PreviewOrganiserBalanceDueEmail from "./components/PreviewOrganiserBalanceDueEmail.vue"
import PreviewOrganiserDepositsReminderEmail from "./components/PreviewOrganiserDepositsReminderEmail.vue"
import PreviewOrganiserPaymentSummaryEmail from "./components/PreviewOrganiserPaymentSummaryEmail.vue"
import EventStatusSelect from "./components/EventStatusSelect.vue"
import pageBadgesMixin from "@/common/PageNameStore/pageBadgesMixin"
import { lookups, loadLookups } from "@/common/companyLookups"
import { noteOrigin } from "@/utils/noteOrigin"

export default {
    mixins: [pageBadgesMixin],
    components: {
        PreviewFinalGuestListEmail,
        PreviewOrganiserEmail,
        PreviewOrganiserItineraryEmail,
        PreviewOrganiserBalanceDueEmail,
        PreviewOrganiserDepositsReminderEmail,
        PreviewOrganiserPaymentSummaryEmail,
        EventStatusSelect,
        SupplierEmailsDialog,
        SupplierTemplateMenu,
        RequestAvailabilityDialog,
    },
    data: () => ({
        loading: true,
        expanded: [],
        singleExpand: false,
        events: [],
        events_total: 0,
        current_page: 1,
        page: 1,
        _search_timer: null,
        notes_dialog: false,
        selected_event: null,
        new_note_content: null,
        filter_start_date: null,
        filter_end_date: null,
        menu1: false,
        menu2: false,
        filter_type: null,
        filter_location: null,
        filter_contributor_id: null,
        filter_booking_status: null,
        search: null,
        view: null,
        weeks: 8,
        weekOptions: [1, 2, 3, 4, 5, 6, 7, 8],
        bookingStatusOptions: [
            { label: 'Booked', value: 'booked' },
            { label: 'Unbooked', value: 'unbooked' },
        ],
        options: {
            chart: {
                type: "area",
                toolbar: {
                    show: false,
                },
                zoom: {
                    enabled: false,
                },
            },
            dataLabels: {
                enabled: false,
            },
            series: [
                {
                    name: "Amount",
                    data: [45, 52, 48, 45, 49, 43, 50],
                }
            ],
            stroke: {
                colors: ['#3988AA'],
                width: 1,
            },
            fill: {
                colors: ['#6ED4F4'],
                type: "gradient",
                gradient: {
                    shadeIntensity: 1,
                    opacityFrom: 0.7,
                    opacityTo: 0.9,
                    stops: [0, 90, 100],
                }
            },
            xaxis: {
                categories: [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul"
                ]
            }
        },
        options2: {
            chart: {
                type: "area",
                toolbar: {
                    show: false,
                },
                zoom: {
                    enabled: false,
                },
            },
            dataLabels: {
                enabled: false,
            },
            series: [
                {
                    name: "Amount",
                    data: [45, 52, 48, 45, 49, 43, 50],
                }
            ],
            stroke: {
                colors: ['#FAAF3A'],
                width: 1,
            },
            fill: {
                colors: ['#FFE1B1'],
                type: "gradient",
                gradient: {
                    shadeIntensity: 1,
                    opacityFrom: 0.7,
                    opacityTo: 0.9,
                    stops: [0, 90, 100],
                }
            },
            xaxis: {
                categories: [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul"
                ]
            }
        },
        organiser_email_dialog: false,
        organiser_email_event: null,
        organiser_itinerary_dialog: false,
        organiser_itinerary_event: null,
        organiser_balance_due_dialog: false,
        organiser_balance_due_event: null,
        organiser_deposits_reminder_dialog: false,
        organiser_deposits_reminder_event: null,
        final_guestlist_dialog: false,
        final_guestlist_event: null,
        payment_summary_dialog: false,
        payment_summary_event: null,
        // The company's email templates, for the Email Suppliers dropdowns.
        email_templates: null,
        loading_templates: false,
        // Which services each supplier was already emailed about, per event on this page
        // (get_sent_services), so the email dialog shows its "Sent" tags at once. Null until loaded.
        sent_services_by_event: null,
        // Services ticked on one event's row: Email Suppliers starts with only those (and their
        // suppliers) ticked. Ticking on another event starts over.
        ticked: { event_id: null, build_ids: [] },
        supplier_email: {
            show: false,
            title: '',
            subtitle: '',
            email_type: null,
            items: [],
            event: null,
            note: '',
        },
        availability: { show: false, event: null, builds: [], supplier_ids: [], product_ids: [] },
    }),
    created() {
        this.view = this.$route.meta.view
        this.setPageName(this.pageTitle)
        // e.g. the dashboard's "Close offs in the next 2 weeks" links to /events/closeoffs?weeks=2
        const weeks = Number(this.$route.query.weeks)
        if (this.view === 'closeoff' && this.weekOptions.includes(weeks)) this.weeks = weeks
    },
    mounted() {
        this.fetchEvents()
        this.loadTemplates()
        loadLookups('event_types', 'advisors', 'locations')
    },
    watch: {
        '$route'(to) {
            this.view = to.meta.view
            this.setPageName(this.pageTitle)
            this.reset()
        },
    },
    computed: {
        getLocation() {
            return lookups.locations
        },
        getEventTypes() {
            return lookups.event_types
        },
        getAdvisors() {
            return lookups.advisors
        },
        ...mapGetters({
            get_user: 'auth/get_user',
            get_selected_company: 'auth/get_selected_company',
        }),
        // FreedomLtd (company 4) doesn't email suppliers from the events lists: no row tick boxes
        // or Email Suppliers button. Its event Suppliers tab is unchanged.
        showSupplierEmails() {
            return this.get_selected_company?.id !== 4
        },
        pageTitle() {
            if (this.view === 'booked') return 'Booked Events'
            if (this.view === 'past') return 'Past Events'
            if (this.view === 'closeoff') return 'Close Offs'
            if (this.view === 'cancelled') return 'Cancelled Events'
            return 'Unbooked Events'
        },
        pageBadges() {
            return [this.events_total.toLocaleString()]
        },
        hasActiveFilters() {
            return !!(this.filter_start_date || this.filter_end_date || this.filter_type || this.filter_location || this.filter_contributor_id || this.filter_booking_status || this.search)
        },
        contributorFilterOptions() {
            return (this.getAdvisors || [])
                .filter(u => u.role?.id !== 1 && (u.access || []).some(a => a.company_id === this.get_selected_company.id))
                .sort((a, b) => (a.role?.id ?? Infinity) - (b.role?.id ?? Infinity))
        },
        computedHeaders() {
            return [
                { text: 'Event', width: '7%', sortable: false },
                { text: 'Organiser', width: '5%', value: 'lead.first_name', sortable: false },
                { text: 'Contributors', width: '1%', sortable: false },
                { text: 'Location', width: '3%', sortable: false },
                { text: 'Event Date', width: '3%', value: 'lead.start_date', sortable: false },
                { text: 'Paid', width: '3%', sortable: false },
                { text: 'Accommodation', width: '12%', sortable: false },
                { text: 'Activities/Food/Other', width: '16%', sortable: false },
                // { text: 'Tags', width: '5%', sortable: false },
                { text: 'Action', width: '7%', sortable: false },
            ]
        },
        // Everything other than Accommodation is grouped into the single Activities/Food/Other column.
        catchAllTypeIds() {
            return [2, 3, 4, 5, 6, 7, 8]
        },
        page_count() {
            return Math.ceil(this.events_total / 15) || 1
        },
        // The open email dialog's event's sent services; null (not loaded yet) lets the dialog
        // load its own.
        dialogSentServices() {
            const event = this.supplier_email.event
            if (!event || !this.sent_services_by_event) return null
            return this.sent_services_by_event[event.id] || []
        },
        // Paid column: organiser + invitees paid in full / deposit only, keyed by event id —
        // same rule as Manage Invitees.
        paymentCounts() {
            return Object.fromEntries(this.events.map(e => [e.id, eventPaymentCounts(e)]))
        },
        // Minimum group size per booked package that has one, keyed by event id
        minimumChecks() {
            return Object.fromEntries(this.events.map(e => [e.id, eventMinimumChecks(e)]))
        },
    },
    methods: {
        noteOrigin,
        ...mapActions({
            setPageName: 'pageNameStore/setPageNameAction',
        }),
        filterContributorOptions(item, queryText) {
            const query = queryText.toLowerCase()
            const name = (item.name || '').toLowerCase()
            const role = (item.role?.name || '').toLowerCase()
            return name.includes(query) || role.includes(query)
        },
        minimumCheckTitle(item, check) {
            const pkg = (item.quotes || []).length > 1 ? ` for ${check.name}` : ''
            const status = check.short > 0 ? `${check.short} more need to pay` : 'minimum met'
            return `Minimum group size${pkg}: ${check.minimum}. ${check.paid} paid in full, ${status}.`
        },
        sortedEventContributors(item) {
            return [...(item.contributors || [])].sort((a, b) => (a.user?.role?.id ?? Infinity) - (b.user?.role?.id ?? Infinity))
        },
        async loadTemplates() {
            this.loading_templates = true
            try {
                this.email_templates = await loadEmailTemplates(this.get_selected_company.id)
            } catch (error) {
                this.email_templates = []
            }
            this.loading_templates = false
        },
        // Sent services for every event on the page, in one request. A slower earlier page's
        // response is dropped.
        async loadSentServices() {
            const request = (this.sent_services_request || 0) + 1
            this.sent_services_request = request
            this.sent_services_by_event = null
            const byEvent = await loadSentServicesForEvents(this.get_selected_company.id, this.events.map(event => event.id))
            if (this.sent_services_request === request) this.sent_services_by_event = byEvent
        },
        // The services shown on an event's row (accommodation first), one array per supplier.
        eventSupplierGroups(item) {
            const builds = [...this.getBuildsOfType(item, 1), ...this.getBuildsOfTypes(item, this.catchAllTypeIds)]
            const groups = []
            builds.forEach(build => {
                const group = groups.find(builds => builds[0].supplier_id === build.supplier_id)
                if (group) group.push(build)
                else groups.push([build])
            })
            return groups
        },
        // The build ids ticked on this event's row, or null when none are.
        tickedFor(item) {
            return this.ticked.event_id === item.id && this.ticked.build_ids.length ? this.ticked.build_ids : null
        },
        isBuildTicked(item, build) {
            return !!this.tickedFor(item) && this.ticked.build_ids.includes(build.id)
        },
        toggleBuild(item, build) {
            const ids = this.ticked.event_id === item.id ? this.ticked.build_ids : []
            this.ticked = {
                event_id: item.id,
                build_ids: ids.includes(build.id) ? ids.filter(id => id !== build.id) : [...ids, build.id],
            }
        },
        onSupplierEmailsSent() {
            if (this.supplier_email.event && this.ticked.event_id === this.supplier_email.event.id) {
                this.ticked = { event_id: null, build_ids: [] }
            }
            this.fetchEvents(this.current_page)
        },
        // Email Suppliers: a template (null: a blank email) to the event's suppliers, all ticked
        // or just the row's ticked services; untick suppliers or services in the dialog.
        openAvailability(item) {
            const ticked = this.tickedFor(item)
            const builds = this.eventSupplierGroups(item).flat()
            const preset = availabilityPreset(ticked ? builds.filter(build => ticked.includes(build.id)) : builds)
            this.availability = { show: true, event: item, builds, ...preset }
        },
        openSupplierEmails(item, template) {
            const ticked = this.tickedFor(item)
            const items = templateEmailItems(this.eventSupplierGroups(item), template, {
                event: item,
                currency: this.get_selected_company.currency,
                // Ticked on the row: only those services and their suppliers; otherwise everyone.
                selected: ticked ? builds => builds.some(build => ticked.includes(build.id)) : null,
                serviceSelected: ticked ? build => ticked.includes(build.id) : null,
            })
            if (!items.length) {
                this.$toast.error('No suppliers to email')
                return
            }
            this.supplier_email = {
                show: true,
                title: `Email Suppliers - ${item.name || item.reference_code || 'Event'}`,
                subtitle: `${template ? template.subject : 'Blank email'}. Untick any supplier or service you don't want to email, then send.`,
                email_type: null,
                items,
                event: item,
                note: templateEmailNote(template),
            }
        },
        async openChangeEmails(item, kind) {
            let groups = this.eventSupplierGroups(item)
            if (kind === 'cancellation') {
                const { data } = await this.$axios.get(`admin/events/get_deleted_quote_builds/${item.id}`)
                if (!data || data.response !== true) {
                    this.$toast.error('Failed to load deleted services')
                    return
                }
                groups = deletedBuildGroups(data.data)
            }
            const dialog = changeEmailDialog(kind, groups, {
                event: item,
                company: this.get_selected_company,
                advisorName: this.get_user ? this.get_user.name : '',
                currency: this.get_selected_company.currency,
                everyone: true,
                // The row's ticks pick live services, not deleted ones.
                ticked: kind === 'cancellation' ? null : this.tickedFor(item),
            })
            if (!dialog.items.length) {
                this.$toast.error(kind === 'cancellation' ? 'No deleted services to cancel' : 'No services to email about')
                return
            }
            this.supplier_email = { show: true, ...dialog, event: item }
        },
        getActivatedQuote(item) {
            return item.quotes.find(q => q.is_activated == 1) || item.quotes[0]
        },
        sortBuildsByDate(builds) {
            return builds.slice().sort((a, b) => (a.start_date || '') < (b.start_date || '') ? -1 : 1)
        },
        getBuildsOfType(item, typeId) {
            return this.getBuildsOfTypes(item, [typeId])
        },
        // Builds of the activated quotes (or the first quote if none are activated), one per
        // supplier booking: copies on variant quotes are folded into the build they copy.
        getBuildsOfTypes(item, typeIds) {
            if (!item.quotes) return []

            const activatedQuotes = item.quotes.filter(q => q.is_activated == 1)
            const quotesToUse = activatedQuotes.length > 0
                ? activatedQuotes
                : (item.quotes[0] ? [item.quotes[0]] : [])

            const allBuilds = []
            quotesToUse.forEach(quote => {
                if (quote.builds) {
                    allBuilds.push(...quote.builds.filter(b => typeIds.includes(b.type_id)))
                }
            })
            return this.sortBuildsByDate(dedupeLinkedBuilds(allBuilds))
        },
        getGroupedBuildsOfTypes(item, typeIds) {
            const typeLabels = { 2: 'Day Activity', 6: 'Night Activity', 8: 'Breakfast', 5: 'Dinner', 4: 'Finger Food', 3: 'Transportation', 7: 'Other' }
            const builds = this.getBuildsOfTypes(item, typeIds)
            return [2, 6, 8, 4, 5, 3, 7]
                .filter(id => typeIds.includes(id))
                .map(id => ({ label: typeLabels[id], builds: builds.filter(b => b.type_id == id) }))
                .filter(group => group.builds.length > 0)
        },
        // Called by the AI Assistant after it changes data: same page, filters and search
        aiRefresh() {
            return this.fetchEvents(this.current_page)
        },
        async fetchEvents(page = 1) {
            this.loading = true
            this.current_page = page
            try {
                const params = { page, per_page: 15 }
                if (this.filter_start_date) params.start_date = this.filter_start_date
                if (this.filter_end_date) params.end_date = this.filter_end_date
                if (this.filter_type) params.type = this.filter_type
                if (this.filter_location) params.location = this.filter_location
                if (this.filter_contributor_id) params.contributor_id = this.filter_contributor_id
                if (this.search) params.search = this.search
                if (this.view === 'booked') {
                    params.booking_status = 'booked'
                    params.event_time = 'upcoming'
                }
                if (this.view === 'unbooked') {
                    params.booking_status = 'unbooked'
                    params.event_time = 'upcoming'
                }
                if (this.view === 'cancelled') params.booking_status = 'cancelled'
                if (this.view === 'past') {
                    params.event_time = 'past'
                    if (this.filter_booking_status) params.booking_status = this.filter_booking_status
                }
                if (this.view === 'closeoff') params.weeks = this.weeks
                const response = await this.$axios.get(
                    `admin/events/get_events_paginated/${this.get_selected_company.id}`,
                    params
                )
                const result = response.data
                if (result.response) {
                    this.events = result.data
                    this.events_total = result.total
                    this.loadSentServices()
                } else {
                    this.events = []
                    this.events_total = 0
                }
                if (this.selected_event) {
                    this.selected_event = this.events.find(e => e.id === this.selected_event.id) || null
                }
            } catch (_) {
                this.events = []
                this.events_total = 0
            }
            this.loading = false
        },
        debounceSearch() {
            clearTimeout(this._search_timer)
            this._search_timer = setTimeout(() => { this.page = 1; this.fetchEvents(1) }, 350)
        },
        openLead(item) {
            this.$router.push({ name: 'EditLeads', params: { id: item.lead.id } })
        },
        manageEvent(item) {
            this.$router.push({ name: 'ManageEvent', params: { event_id: item.id } })
        },
        changeStartDate() {
            this.menu1 = false
            this.fetchEvents(1)
        },
        changeWeeks() {
            this.fetchEvents(1)
        },
        changeEndDate() {
            this.menu2 = false
            this.fetchEvents(1)
        },
        reset() {
            this.filter_start_date = null
            this.filter_end_date = null
            this.filter_type = null
            this.filter_location = null
            this.filter_contributor_id = null
            this.filter_booking_status = null
            this.search = null
            this.page = 1
            this.fetchEvents(1)
        },
        hasOrganiserEmailBeenSent(item, email_type) {
            return !!(item.email_histories && item.email_histories.some(h => h.email_type === email_type))
        },
        sendOrganiserEmail(item) {
            this.organiser_email_event = item
            this.organiser_email_dialog = true
        },
        closeOrganiserEmailDialog() {
            this.organiser_email_dialog = false
            this.organiser_email_event = null
        },
        openSendOrganiserItineraryDialog(item) {
            this.organiser_itinerary_event = item
            this.organiser_itinerary_dialog = true
        },
        closeSendOrganiserItineraryDialog() {
            this.organiser_itinerary_dialog = false
            this.organiser_itinerary_event = null
        },
        openSendOrganiserBalanceDueDialog(item) {
            this.organiser_balance_due_event = item
            this.organiser_balance_due_dialog = true
        },
        closeSendOrganiserBalanceDueDialog() {
            this.organiser_balance_due_dialog = false
            this.organiser_balance_due_event = null
        },
        openSendOrganiserDepositsReminderDialog(item) {
            this.organiser_deposits_reminder_event = item
            this.organiser_deposits_reminder_dialog = true
        },
        closeSendOrganiserDepositsReminderDialog() {
            this.organiser_deposits_reminder_dialog = false
            this.organiser_deposits_reminder_event = null
        },
        openSendFinalGuestListDialog(item) {
            this.final_guestlist_event = item
            this.final_guestlist_dialog = true
        },
        closeSendFinalGuestListDialog() {
            this.final_guestlist_dialog = false
            this.final_guestlist_event = null
        },
        openSendPaymentSummaryDialog(item) {
            this.payment_summary_event = item
            this.payment_summary_dialog = true
        },
        closeSendPaymentSummaryDialog() {
            this.payment_summary_dialog = false
            this.payment_summary_event = null
        },
        paymentSummaryRowsFor(event) {
            return paymentSummaryRows(event)
        },
        hasEventNotes(item) {
            return !!(item.event_notes && item.event_notes.length > 0)
        },
        openNotesDialog(item) {
            this.notes_dialog = true
            this.selected_event = item
            this.new_note_content = null
        },
        closeNotesDialog() {
            this.notes_dialog = false
            this.selected_event = null
            this.new_note_content = null
        },
        async createEventNote() {
            if (!this.new_note_content) return
            const response = await this.$axios.post('admin/events/create_event_note', {
                event_id: this.selected_event.id,
                note_content: this.new_note_content,
            })
            const result = response.data
            if (result.response == true) {
                this.$toast.success('Note added')
                this.new_note_content = null
                this.fetchEvents(this.current_page)
            } else {
                this.$toast.error('Failed to add note')
            }
        },
        async deleteEventNote(note) {
            const response = await this.$axios.delete(`admin/events/delete_event_note/${note.id}`)
            const result = response.data
            if (result.response == true) {
                this.$toast.success('Note deleted')
                this.fetchEvents(this.current_page)
            } else {
                this.$toast.error('Failed to delete note')
            }
        },
        stripParenthetical(text) {
            if (!text) return ''
            return text.replace(/\s*\([^)]*\)/g, '').trim()
        },
        // EventStatusSelect has already asked for CONFIRM if this unlocks a Booking Closed event
        async updateEventStatus(event, status) {
            const previous = event.event_status
            event.event_status = status
            try {
                const payload = {
                    company_id: this.get_selected_company.id,
                    id: event.id,
                    event_status: status,
                }
                const response = await this.$axios.post(`admin/events/update_event/${event.id}`, payload)
                const result = response.data
                if (result.response == true) {
                    this.$toast.success('Event status updated')
                    await this.addStatusChangeNote(event, status)
                } else {
                    event.event_status = previous
                    this.$toast.error('Failed to update event status')
                }
            } catch (error) {
                event.event_status = previous
                this.$toast.error('Error updating event status')
                console.error(error)
            }
        },
        // The status itself is already saved, so a failed note only warns rather than reverting it
        async addStatusChangeNote(event, status) {
            try {
                const result = (await this.$axios.post('admin/events/create_event_note', {
                    event_id: event.id,
                    note_content: `Changed status to ${status}`,
                })).data
                if (result.response == true) {
                    this.$set(event, 'event_notes', [...(event.event_notes || []), result.data])
                } else {
                    this.$toast.error('Status updated but failed to add note')
                }
            } catch (error) {
                this.$toast.error('Status updated but failed to add note')
                console.error(error)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.paid-bar {
    display: flex;
    height: 10px;
    min-width: 60px;
    border-radius: 20px;
    overflow: hidden;
    background-color: #D7D7D7;
}

.paid-bar-full {
    background-color: #4CAF50;
}

.paid-bar-deposit {
    background-color: #FFA726;
}

.paid-counts {
    display: flex;
    flex-direction: column;
    margin-top: 3px;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.3;
    white-space: nowrap;
}

.paid-count-full {
    color: #2E7D32;
}

.paid-count-deposit {
    color: #E65100;
}

.min-check {
    margin-top: 3px;
    font-size: 11px;
    font-weight: 700;
    white-space: nowrap;
}

.min-check--short {
    color: #C62828;
}

.min-check--ok {
    color: #2E7D32;
}

.event-name-link {
    color: #3988AA;
    text-decoration: underline;
    display: inline-block;
}

.booking-dialog-card {
    border-radius: 12px !important;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    max-height: 90vh;
}

.booking-dialog-card>.v-card__text {
    overflow-y: auto;
    flex: 1;
}

.booking-dialog-header {
    background: linear-gradient(135deg, #3988AA 0%, #2a6a88 100%);
}

.booking-dialog-title {
    font-family: Manrope;
    font-size: 18px;
    font-weight: 700;
    color: white;
    display: flex;
    align-items: center;
}

.embossed-hover {
    transition: all 0.2s ease-in-out;
}

.embossed-hover:hover {
    background-color: #cccccc99;
    box-shadow: inset 1px 1px 3px #ccc, inset -1px -1px 3px #f1f1f1;
    border-radius: 4px;
}

.card-format {
    border-radius: 10px !important;
    border: 1px solid #E9E9E9 !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
    margin-bottom:100px;

    .v-data-footer {
        background-color: #F7F7F7;
        color: #7C7C7C;
        font-family: Manrope;
        border-top: 1px solid #E9E9E9;
    }

    .v-data-footer__select .v-text-field {
        background-color: white;

        .v-select__slot {
            padding-left: 10px;
        }
    }
}

:deep(tbody tr:hover) {
    background-color: transparent !important;
}

:deep(.theme--light.v-data-table tbody td) {
    height: 90px;
    border: none;
}

.label-text-color {
    color: #7C7C7C;
}

.text-proper-case {
    text-transform: capitalize;
}

.search-text-field {
    margin-top: 15px;

    .v-input__slot {
        min-height: 0 !important;
        margin-top: 8px;
    }

    .v-input__prepend-inner {
        margin-top: 5px !important;
    }
}

:deep(.custom-buttons span) {
    text-transform: none;
    font-family: Manrope;
    font-size: 14px !important;
    font-style: normal;
    font-weight: 600 !important;
    line-height: normal;
    box-shadow: none !important;
}

:deep(.custom-buttons button) {
    padding: 8px 7px 8px 7px !important;
    border-radius: 5px;
}

.sticky-pagination {
    position: fixed;
    bottom: 20px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    z-index: 100;
    pointer-events: none;

    ::v-deep .v-pagination {
        pointer-events: all;
        background: white;
        border-radius: 8px;
        padding: 4px 8px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
    }
}

.card-section-header {
    background: linear-gradient(135deg, #3988AA 0%, #2a6a88 100%);
}

.card-section-title {
    font-family: Manrope;
    font-size: 16px;
    font-weight: 700;
    color: white;
}


.header-filter-input ::v-deep .v-input__control {
    background: white;
    border-radius: 4px;
}

.date-range-wrapper {
    display: flex;
    align-items: center;
    background: white;
    border-radius: 4px;
    padding: 0 8px;
    height: 40px;
}

.date-range-input ::v-deep .v-input__slot::before {
    border-style: none !important;
}

.header-clear-row {
    margin: 6px 0 -8px -8px;
}

.header-clear-btn {
    font-family: Manrope;
    font-weight: 600 !important;
    font-size: 12px !important;
    text-transform: none;
    color: white !important;
}

.header-outline-btn {
    background: rgba(255, 255, 255, 0.15) !important;
    color: white !important;
    border-color: rgba(255, 255, 255, 0.5) !important;
}

.header-create-btn {
    background: white !important;
    color: #3988AA !important;
}

.events-header-btn {
    font-family: Manrope;
    font-weight: 600 !important;
    font-size: 13px !important;
    text-transform: none;
    height: 36px !important;
    padding: 0 14px !important;
}

.events-action-btn {
    font-family: Manrope;
    font-weight: 600 !important;
    font-size: 13px !important;
    text-transform: none;
}

/* Email Organiser and Email Suppliers stacked, the expand toggle centred to their right */
.event-actions {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 6px 0;
}

.event-actions-buttons {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.event-actions-buttons .v-btn {
    width: 100%;
    white-space: nowrap;
    font-size: 11px !important;
}

.contributor-row {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    white-space: nowrap;
}

.contributor-row .v-chip {
    flex-shrink: 0;
}

:deep(.v-input__slot::before) {
    border-style: none !important;
}

.build-row-item {
    padding: 8px 0;
}

.build-row-item+.build-row-item {
    border-top: 1px solid #C7C7C7;
}

.build-group+.build-group {
    margin-top: 6px;
}

.build-group-label {
    color: #7C7C7C;
    font-family: Manrope;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    margin-bottom: 2px;
}

.label-1 {
    color: #7C7C7C;
    background-color: #F7F7F7;
    font-size: 11px;
    border: solid 1px #7C7C7C;
    border-radius: 4px;
    padding: 3px 5px;
}

.label-2 {
    color: #EE9E25;
    background-color: #FFF3E2;
    font-size: 11px;
    border: solid 1px #EE9E25;
    border-radius: 4px;
    padding: 3px 5px;
}

.label-3 {
    color: #669E53;
    background-color: #E6F3E2;
    font-size: 11px;
    border: solid 1px #669E53;
    border-radius: 4px;
    padding: 3px 5px;
}

.label-4 {
    color: #AA3939;
    background-color: #FFCFCF;
    font-size: 11px;
    border: solid 1px #AA3939;
    border-radius: 4px;
    padding: 3px 5px;
}

:deep(.v-chip.label-1) {
    background-color: #F7F7F7 !important;
    color: #7C7C7C !important;
    border: solid 1px #7C7C7C !important;
}

:deep(.v-chip.label-2) {
    background-color: #FFF3E2 !important;
    color: #EE9E25 !important;
    border: solid 1px #EE9E25 !important;
}

:deep(.v-chip.label-3) {
    background-color: #E6F3E2 !important;
    color: #669E53 !important;
    border: solid 1px #669E53 !important;
}

:deep(.v-chip.label-4) {
    background-color: #FFCFCF !important;
    color: #AA3939 !important;
    border: solid 1px #AA3939 !important;
}

:deep(.v-chip.label-5) {
    background-color: #EFE6F8 !important;
    color: #6A4C93 !important;
    border: solid 1px #9B7BC4 !important;
}

.custom-label {
    color: #669E53;
    background-color: #E6F3E2;
    font-size: 11px;
    border-radius: 20px;
    padding: 5px 10px;
    margin-right: 10px;
}

.notes-square-btn {
    width: 25px;
    height: 25px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    background-color: #D7D7D7;
    color: white;
    font-size: 16px;
    font-weight: 700;
    line-height: 1;
    border: none;
    cursor: pointer;
    transition: background-color 0.15s;

    &--active {
        background-color: #27AE60;
    }

    &:hover {
        opacity: 0.85;
    }
}

:deep(.event-status-select .v-input__slot::before),
:deep(.event-status-select .v-input__slot::after) {
    display: none !important;
}

:deep(.event-status-select) {
    width: 165px !important;
    min-width: 165px !important;
    max-width: 165px !important;
}

:deep(.event-status-select .v-chip) {
    max-width: 165px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

:deep(.event-status-select .v-chip__content) {
    display: flex;
    align-items: center;
    max-width: 100%;
    overflow: hidden;
}

.notes-container {
    max-height: 220px;
    overflow-y: auto;
    padding: 4px;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
        background: #C4C4C4;
        border-radius: 10px;

        &:hover {
            background: #A0A0A0;
        }
    }
}

.no-notes {
    text-align: center;
    padding: 24px;
    color: #999;
    font-size: 13px;
    font-style: italic;
}

.note-item {
    background-color: white;
    border: 1px solid #E0E0E0;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 8px;
    transition: box-shadow 0.2s, border-color 0.2s;

    &:hover {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        border-color: #C0C0C0;
    }

    &:last-child {
        margin-bottom: 0;
    }
}

.note-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
}

.note-meta {
    display: flex;
    gap: 2px;
}

.note-date {
    font-size: 10px;
    color: #999;
    font-weight: 500;
}

.note-author {
    font-size: 11px;
    color: #3498DB;
    font-weight: 600;
}

.note-content {
    font-size: 13px;
    color: #2C3E50;
    line-height: 1.5;
    white-space: pre-wrap;
    word-break: break-word;
}
</style>